import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'

export const isLPToken = (token: WrappedTokenInfo): boolean => {
  const symbol = token.symbol.toLowerCase()
  const name = token.name.toLowerCase()

  return (
    symbol === 'uni-v2' ||
    symbol.includes('-lp') ||
    name.includes('lp token') ||
    name.includes('|') ||
    symbol.includes('KODI') ||
    symbol.includes('CHRM') ||
    symbol.includes('Bault') ||
    (token.tags ?? []).some((tag) => tag?.id === 'island') ||
    (token.tags ?? []).some((tag) => tag?.id === 'bault') ||
    (token.tags ?? []).some((tag) => tag?.id === 'charm') ||
    (token.tags ?? []).some((tag) => tag?.id === 'v2')
  )
}
